import { deepFreeze } from '../../../utils/objectUtils';

export const adSizes = deepFreeze({
  billboard: [
    [970, 250],
    [1000, 350],
    [1000, 300],
    [1000, 200]
  ],
  billboard_970x250: [970, 250],
  top_placement_large_desktop: [1280, 320],
  top_placement_small_desktop: [1024, 256],
  top_placement_tablet: [728, 90],
  top_placement_smartphone: [375, 125],
  leaderboard: [728, 90],
  medium_rectangle: [300, 250],
  half_page: [300, 600],
  pushdown: [
    [970, 90],
    [970, 66]
  ],
  mobile_static_banner: [320, 50],
  unknown_name_300x50: [300, 50],
  unknown_name_320x240: [320, 240],
  teads: [1, 3]
});
